import React, {Fragment} from 'react';
import { useLocation } from 'react-router';
import Diamonds from './diamonds';
import Parcel from './parcels';
import Jewelery from './jewelery';
import ColorStone from './colorStone';
import Watch from './watch';
import WeddingBand from './weddingBands';
import { getSecondLastURL } from '../../helper';
import EmptyPage from '../layout/404';
import { FormattedMessage } from 'react-intl';


const Index = () => {

    const location = useLocation();
    const pathname = getSecondLastURL(location)

    return (
        <Fragment>
            {
                pathname === 'diamonds' ?
                 <Diamonds />
                :
                pathname === 'parcels' ?
                 <Parcel />
                : 
                pathname === 'jewellery' ?
                  <Jewelery />
                :
                pathname === 'color-stones' ?
                  <ColorStone />
                :
                pathname === 'watches' ?
                  <Watch />
                :
                pathname === 'wedding-bands' ?
                  <WeddingBand />
                :
                <EmptyPage />
            }


            <div className="modal fade" id="ratingInfoDetails" tabIndex="-1" role="dialog" aria-labelledby="ratingInfoDetails" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content bg-white">
                        {/* <div className="modal-header align-items-center">
                            <h4 className="modal-title">
                              <strong>
                              <FormattedMessage id="rating.main.heading" defaultMessage="Review Info"/>
                              </strong>
                              </h4>
                            <button id="dismiss-modal" type="button" className="close m-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> */}
                            
                        <div className="modal-body">

                          <h5>
                            <strong>
                              <FormattedMessage
                                  id="rating.privacy.heading"
                                  defaultMessage="How we protect your privacy"
                              />
                              </strong>
                          </h5>

                          <p>
                              <FormattedMessage
                                  id="rating.privacy.text.part1"
                                  defaultMessage="Your identity and specific purchase details are kept strictly"
                              />{" "}
                              <strong>
                                  <FormattedMessage
                                      id="rating.privacy.text.part2"
                                      defaultMessage="confidential."
                                  />
                              </strong>
                            {" "}
                              <FormattedMessage
                                  id="rating.privacy.text.part3"
                                  defaultMessage="To ensure total anonymity, we delay the publication of all reviews by 14 days, preventing any link back to your specific transaction."
                              />
                          </p>

                          <h5 className="mt-3">
                            <strong>
                              <FormattedMessage
                                  id="rating.voice.heading"
                                  defaultMessage="The value of your voice"
                              />
                              </strong>
                          </h5>

                          <p>
                              <FormattedMessage
                                  id="rating.voice.description"
                                  defaultMessage="Honest feedback empowers our community to make informed decisions and allows us to refine our services for you."
                              />
                          </p>

                          <h5 className="mt-3">
                            <strong>
                              <FormattedMessage
                                  id="rating.process.heading"
                                  defaultMessage="Our process"
                              />
                              </strong>
                          </h5>

                          <p>
                              <FormattedMessage
                                  id="rating.process.description"
                                  defaultMessage="Simply share your experience after use. Your feedback will be shared with the community to help us shape a better future experience."
                              />
                          </p>

                      
                      <div className='text-center'>
                            <button id="dismiss-modal" type="button"  data-dismiss="modal" aria-label="Close" className="btn btn-black p-2">
                                <FormattedMessage id="rating.got.thanks" defaultMessage="Got it, Thanks!"/>
                            </button>
                      </div>
                      
                     </div>
                    </div>
              
                </div>
            </div>
        </Fragment>
    )
}

export default Index
